// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2SJEr","col":"styles_col__36rZ8"};